var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeMobile4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 133 105",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.61829 61.0315C-12.9817 122.699 44.9299 105.672 75.8356 89.4496C197.056 33.2636 89.9594 -23.0995 76.156 9.70007C62.3526 42.4997 22.1182 -16.0528 2.61829 61.0315Z",
  fill: "current"
})));
export default SvgShapeMobile4;